import { lazyLoad } from 'utils/loadable';

export const SitemapRobotsSettings = lazyLoad(
  () => import('./index'),
  module => module.SitemapRobotsSettings,
);
